import * as _ from 'lodash';
import { RECEIVE_BULK_UPLOAD_DIFFS } from '@Actions/bulk_upload';
import { CLEAR_PROCESSING_FAILURE, RECORD_PROCESSING_FAILURE, SAVE_CSV_DATA, SET_PREVIEW_TAB, TOGGLE_CHANGE_TO_APPLY, TOGGLE_CONFIRMING_CHANGES, TOGGLE_VIEWING_ERROR_DETAILS } from '@Actions/index';
export const defaultState = {
    loadingDiffs: false,
    allDiffs: [],
    addDiffs: [],
    enableDiffs: [],
    updateDiffs: [],
    disableDiffs: [],
    unchangedDiffs: [],
    errorDiffs: [],
    changesToApply: {
        add: true,
        enable: true,
        update: true,
        disable: false
    },
    error: null,
    viewingErrorDetails: false,
    confirmingChanges: false,
    openTab: null,
    savedCsv: null
};
export function bulkUploadReducer(state = defaultState, action) {
    switch (action.type) {
        case RECEIVE_BULK_UPLOAD_DIFFS:
            return _.assign({}, state, {
                loadingDiffs: false,
                allDiffs: action.diffs,
                addDiffs: action.diffs.filter((diff) => diff.action === 'ADD' || diff.action === 'REISSUE_INVITE'),
                enableDiffs: action.diffs.filter((diff) => diff.action === 'ENABLE'),
                updateDiffs: action.diffs.filter((diff) => diff.action === 'UPDATE'),
                disableDiffs: action.diffs.filter((diff) => diff.action === 'DISABLE' || diff.action === 'REVOKE_INVITE'),
                unchangedDiffs: action.diffs.filter((diff) => diff.action === 'UNCHANGED')
            });
        case TOGGLE_CHANGE_TO_APPLY:
            return _.assign({}, state, {
                changesToApply: _.assign({}, state.changesToApply, action.change)
            });
        case TOGGLE_CONFIRMING_CHANGES:
            return _.assign({}, state, {
                confirmingChanges: !state.confirmingChanges
            });
        case RECORD_PROCESSING_FAILURE:
            return _.assign({}, state, {
                error: action.error,
                errorDiffs: action.diffs.filter((diff) => diff.fieldErrorMap && Object.keys(diff.fieldErrorMap).length)
            });
        case CLEAR_PROCESSING_FAILURE:
        case 'CLOSE_MODAL':
            return _.assign({}, state, {
                error: null,
                errorDiffs: []
            });
        case TOGGLE_VIEWING_ERROR_DETAILS:
            return _.assign({}, state, {
                viewingErrorDetails: !state.viewingErrorDetails
            });
        case SET_PREVIEW_TAB:
            return _.assign({}, state, {
                openTab: action.change
            });
        case SAVE_CSV_DATA:
            return _.assign({}, state, {
                savedCsv: action.data
            });
        default:
            return state;
    }
}
